import React from 'react';
import { useSelector } from 'react-redux';
import { Navigate, Outlet } from 'react-router-dom';

import { useSiteCapabilityCheck } from '../../../common/hooks/use-site-capability-check';
import { selectSite } from '../../../features/site/siteSlice';

export function VPPRoutes() {
  const { site_id: siteId } = useSelector(selectSite);
  const { siteHasInverter } = useSiteCapabilityCheck();
  // All VPP features require an inverter, if a user somehow ends up here without a inverter --
  // -- we redirect them home
  if (!siteHasInverter) {
    console.error('Site doesnt have the required hardware for VPP');
    return <Navigate to={`/site/${siteId}/home`} />;
  }
  return <Outlet />;
}
